/**
 * Centralized configuration for API endpoints.
 * 
 * In development, we typically use the proxy in package.json (so base URL is empty).
 * In production (Cloudflare), we need to point to the Railway backend.
 */

export const getApiBaseUrl = () => {
    if (process.env.NODE_ENV === 'production') {
        // If REACT_APP_API_BASE_URL is set (in Cloudflare), use it.
        // Otherwise fallback to empty string (which implies same-origin, probably failing on CF)
        return process.env.REACT_APP_API_BASE_URL || '';
    }

    // In development, return empty string to let the proxy handle it
    return '';
};
